import React from 'react';

import styles from './reportfilters.module.css';
import { Form, DatePicker, Select, Switch } from 'antd';
import SurveysService from '../SurveysService';
import { FieldData } from 'rc-field-form/es/interface';
import moment from 'moment';

interface ReportFiltersProps {
  client: string,
  surveyId: number,
  initialFilters?: any,
  onFiltersChange: (filters: any) => void
}

interface ReportFiltersState {
  loading: boolean,
  tags?: any[],
  filters: any
}

class ReportFilters extends React.Component<ReportFiltersProps, ReportFiltersState> {

  state: ReportFiltersState = {
    loading: false,
    filters: { from: moment().add(-7, 'days').format('YYYY-MM-DD'), to: moment().format('YYYY-MM-DD') }
  }


  notifyChange = () => {
    if(this.props.onFiltersChange) this.props.onFiltersChange(this.state.filters);
  }

  async componentDidMount() {
    this.setState({ filters: this.props.initialFilters || {} });
    if(this.props.surveyId) await this.queryTags();
  }

  async componentDidUpdate(prevProps: ReportFiltersProps) {
    if(this.props.surveyId !== prevProps.surveyId && this.props.surveyId) {
      await this.queryTags();
    }
  }

  queryTags = async () => {
    const { client, surveyId } = this.props;
    const tags = await SurveysService.getSurveyTags(client, surveyId);
    this.setState({ tags });
  }

  onFiltersChange = (changed: FieldData[], all: FieldData[]) => {
    const filters = all.reduce((prev: any, curr:FieldData) => {
      if(curr.value) {
        const val = moment.isMoment(curr.value) ? curr.value.format('YYYY-MM-DD') : curr.value;
        prev[curr.name.toString()] = val;
      }
      
      return prev;
    }, {});
    console.log('filters changed', filters);
    this.setState({ filters }, this.notifyChange);
  }

  render() {
    const { tags } = this.state;
    const { initialFilters } = this.props;

    return <Form id="frmRptFlt" layout="vertical" className={styles.filters} onFieldsChange={this.onFiltersChange}>
            <Form.Item label="Fecha inicial" name="from" initialValue={moment().add(-7, 'days')}>
              <DatePicker format="DD/MM/YYYY" />
            </Form.Item>
            <Form.Item label="Fecha final" name="to" initialValue={moment()}>
              <DatePicker format="DD/MM/YYYY" />
            </Form.Item>
            { (tags||[]).map((t:any) => 
              <Form.Item label={t.name} name={t.type === 'question' ? `q_${t.id}` : t.type === 'query' ? `qs_${t.id}` : t.name} key={t.name} initialValue={(initialFilters??{})[t.name]}>
                <Select
                  mode="multiple"
                  style={{minWidth: '200px', width: '100%'}}
                  placeholder={`Todos`} getPopupContainer={() => document.getElementById('frmRptFlt') || document.body }>
                  {t.values.map((v:any) => <Select.Option key={v} value={t.type !== 'tag' ? v.split(';')[1] : v} >{t.type !== 'tag' ? v.split(';')[0] : v}</Select.Option>)}
                </Select>
              </Form.Item>
            )}
            <Form.Item label="¿Sólo códigos activos?" valuePropName="checked" name="only_active" initialValue={false}>
              <Switch />
            </Form.Item>
          </Form>;
  }
}

export default ReportFilters;
